import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/PlusCircleOutlinedStandard.js";
import o from "../components/PfIcon.js";
const r = (t, e) => {
  const l = {
    ...t,
    ...e.attrs
  };
  return a(o, i(l, {
    icon: n
  }), null);
};
r.displayName = "PlusCircleOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
